import React, { useEffect } from "react";
import {
  CommonModalDwebStyle,
  CommonModalHeader,
  CrossIconWrap,
} from "./CommonModalDweb.style";

import {
  BackDropComp,
  FormattedText,
  H5Tag,
  ImageComponent,
  ReactPortalComp,
} from "@tm/static";
import { theme } from "@tm/utility/global";
import { TextNodeType } from "../FormattedText/FormattedText";

interface ModalInterface {
  children?: React.ReactNode;
  customTitle?: string | TextNodeType;
  customTitleComponent?: React.ReactNode;
  requiredField?: boolean;
  handleClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  crossIcon?: string;
  customWidth?: string;
  customIcon?: string;
  errorModal?: boolean;
  nonClipHeading?: boolean;
}

const CommonModalDweb = ({
  children,
  customTitle,
  handleClick,
  requiredField,
  crossIcon,
  customWidth,
  customIcon,
  errorModal,
  nonClipHeading,
  customTitleComponent,
}: ModalInterface) => {
  useEffect(() => {
    const parentElement = document.getElementById("parent-section");
    parentElement ? (parentElement.style.overflow = "unset") : "";
    return () => {
      parentElement ? (parentElement.style.overflowY = "scroll") : "";
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <ReactPortalComp>
      <CommonModalDwebStyle customWidth={customWidth}>
        <CommonModalHeader nonClipHeading={nonClipHeading}>
          <H5Tag color={errorModal ? theme.redText : theme.blackText}>
            {customIcon && (
              <ImageComponent width="40px" height="40px" src={customIcon} />
            )}
            {customTitleComponent}
            {customTitle && <FormattedText value={customTitle} />}
          </H5Tag>
          <CrossIconWrap onClick={handleClick}>
            <ImageComponent
              width="28px"
              height="28px"
              src="https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg"
            />
          </CrossIconWrap>
        </CommonModalHeader>
        {children}
      </CommonModalDwebStyle>
      <BackDropComp onClose={handleClick} />
    </ReactPortalComp>
  );
};

export default CommonModalDweb;
